import { render, staticRenderFns } from "./CaseCreateStatusDashboard.vue?vue&type=template&id=180c6958&scoped=true&"
import script from "./CaseCreateStatusDashboard.vue?vue&type=script&lang=js&"
export * from "./CaseCreateStatusDashboard.vue?vue&type=script&lang=js&"
import style0 from "./CaseCreateStatusDashboard.vue?vue&type=style&index=0&id=180c6958&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "180c6958",
  null
  
)

export default component.exports